import { render } from "./Mailbox.vue?vue&type=template&id=4238d9f0&scoped=true"
import script from "./Mailbox.vue?vue&type=script&lang=js"
export * from "./Mailbox.vue?vue&type=script&lang=js"

import "./Mailbox.vue?vue&type=style&index=0&id=4238d9f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4238d9f0"]])

export default __exports__